<script>
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import router from "@/router";
import {useStore} from "vuex";

export default {
  name: "MyAdvertising",
  components: {LoadingPage},
  setup(){

    let store = useStore()

    let loading = ref(false)
    let my_ads = ref([])

    function get_ads() {
    loading.value = true
    FreeWorld.Heisenberg({action:'my_adver'} , 'manage_adver' , true).then((res)=>{
      loading.value = false
      my_ads.value = res.data
    }).catch((res)=>{
      loading.value = false
      Swals.Catch(res , get_ads)
    })
    }
    get_ads()

    function delete_ads(item) {
      Swals.Question('آیا از حذف آگهی ' + item.title + ' اطمینان دارید؟' , 'حذف').then((res)=>{
        if (res.isConfirmed){
          loading.value = true
          FreeWorld.Heisenberg({action:'delete' , adver_id:item.id} , 'manage_adver' , true).then((res)=>{
            loading.value = false
            if (res.data.status === 'ok'){
              Swals.Done('آگهی شما با موفقیت حذف شد')
              get_ads()
            }else {
              Swals.Fault('متاسفانه آگهی شما حذف نشد!')
            }
          }).catch((res)=>{
            loading.value = false
            Swals.Catch(res , get_ads)
          })
        }
      })
    }

    function edit_ads(item) {
      let data = {
        adver_category_id: item.adver_category_id,
        state_id: item.state_id,
        city_id: item.city_id,
        street_id: item.street_id,
      }
      store.commit('set_add_advertising' , data)
      store.commit('set_advertising' , item)
      router.push({name:'AddAdvertising' , params:{action: 'edit'}})
    }

    function seen_ads(item) {
      item.pics = []
      if (item.pic1 !== null) item.pics.push(item.pic1)
      if (item.pic2 !== null) item.pics.push(item.pic2)
      if (item.pic3 !== null) item.pics.push(item.pic3)
      if (item.pic4 !== null) item.pics.push(item.pic4)

      store.commit('set_advertising' , item)
      router.push({name:'DetailsAdvertising'})
    }

    return{
      loading,
      my_ads,
      seen_ads,
      delete_ads,
      edit_ads,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
      <p class="text-white font-bold font-4">آگهی های من</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <div v-if="my_ads.length === 0"
           class="animate__animated animate__fadeIn w-100 h-75 d-flex justify-content-center">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img style="width: 10rem" src="../assets/img/icon-recruitment.svg" alt="" class="mb-4">
          <p class="font-4 text-center">در حال حاضر آیتمی وجود ندارد...!</p>
        </div>
      </div>

      <div v-else v-for="item in my_ads" :key="item.id" class="bg-white shadow-custom p-2 d-flex justify-content-between rounded-4 mb-3">
        <div class="d-flex flex-column justify-content-around w-60">
          <p class="text-color font-bold font-4">{{ item.title }}</p>

          <p v-if="item.price > 0" class="font-5">{{ item.price.toLocaleString() }} تومان</p>
          <p v-else class="font-5">توافقی</p>

          <div class="hr-dash my-3"></div>

          <div class="d-flex align-items-center w-40 justify-content-between">
            <div @click="edit_ads(item)" style="width: 2.5rem;height: 2.5rem" class="p-2 bg-yellow shadow rounded-2 d-flex justify-content-center align-items-center">
              <img class="icon-size-0-5" src="../assets/img/icon-editingPen.svg" alt="">
            </div>

            <div @click="delete_ads(item)" style="width: 2.5rem;height: 2.5rem" class="p-2 bg-red shadow rounded-2 d-flex justify-content-center align-items-center">
              <img class="icon-size-0-5" src="../assets/img/icon-binColor.svg" alt="">
            </div>
          </div>
        </div>

        <div @click="seen_ads(item)" class="img-ads rounded-4 animated-background">
          <img class="img-ads rounded-4" :src="item.pic1" alt="">
        </div>
      </div>

    </div>
  </div>

</template>

<style scoped>
.img-ads {
  width: 10rem;
  height: 10rem;
}
.hr-dash{
  width: 100%;
  height: .1rem;
  border-bottom: .1rem dashed #0335BE ;
}
</style>